import { render, staticRenderFns } from "./LicencaModal.vue?vue&type=template&id=68bb04aa&scoped=true"
import script from "./LicencaModal.vue?vue&type=script&lang=js"
export * from "./LicencaModal.vue?vue&type=script&lang=js"
import style0 from "./LicencaModal.vue?vue&type=style&index=0&id=68bb04aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb04aa",
  null
  
)

export default component.exports